import { ThemeDefinition } from 'vuetify'

export default {
  light: {
    dark: false,
    colors: {
      primary: '#51b84b',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF3739',
      info: '#00D0BD',
      success: '#4CAF50',
      warning: '#FFB70F',
      base: '#F4F7FA',
      background: '#F4F7FA',
      surface: '#FFFFFF',
      scroll: '#E0E0E0',
      subtext: '#616161'
    }
  } as ThemeDefinition,
  dark: {
    dark: true,
    colors: {
      primary: '#51b84b',
      secondary: '#B0B0B0',
      accent: '#E93FF4',
      error: '#8C1D18',
      info: '#00D0BD',
      success: '#4CAF50',
      warning: '#8C1D18',
      base: '#1B1B1B',
      background: '#121212',
      surface: '#212121',
      scroll: '#444746',
      subtext: '#C4C7C5'
    }
  } as ThemeDefinition
}
